import { createContext, useContext } from "react";

/** true cuando el contenido se muestra dentro del Viewer (solo lectura). */
export const ViewerContext = createContext(false);

export function useViewer() {
	return useContext(ViewerContext);
}
